import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Cog from './icon-cog.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Cog {...validProps} />;
}
SvgComponent.iconName = 'cog';

/**
 * @deprecated This is a legacy icon
 */
export const CogIcon = svgIconWrapper(SvgComponent);
